import DenunciaFormDatosGenerales from "@/pages/sumario/DenunciaFormDatosGenerales";
import DenunciaForm from "@/pages/sumario/DenunciaForm";
import NotificacionesActuacion from "@/pages/NotificacionesActuacion.vue";
import DenunciaFormDenunciante from "@/pages/sumario/DenunciaFormDenunciante";
import isRolUserGuard from "@/guards/isUserRolGuard";

import { actuacionesConfig } from "./RoutesConfig/actuacionesConfig/actuacionesConfig";

function findPropsForRoute(pathName) {
  const link = actuacionesConfig.find((link) => link.pathName === pathName);
  return link ? link.props : {};
}

export default {
  //actuaciones/''
  component: () => import("@/pages/sumario/LayoutActuaciones"),
  children: [
    {
      path: "",
      name: "actuaciones",
      beforeEnter: isRolUserGuard,
      redirect: "list",
    },
    {
      path: "list",
      name: "listadoActuaciones",
      component: () => import("@/pages/sumario/SumarioHomePage"),
    },
    {
      path: "view/:id",
      name: "view-id",
      component: DenunciaFormDatosGenerales,
      meta: { showBackButton: true },
    },
    {
      path: "notificaciones/:id",
      name: "actuacion-notificaciones",
      component: NotificacionesActuacion,
    },
    {
      path: ":mode/:pathName/initial",
      name: "actuacion-initial",
      meta: { showBackButton: true },
      component: DenunciaForm,
      props: (route) => findPropsForRoute(route.params.pathName),
    },
    {
      path: ":mode/:pathName/initial/denunciante",
      name: "actuacion-form-denunciante",
      component: DenunciaFormDenunciante,
      props: (route) => findPropsForRoute(route.params.pathName),
    },
    {
      path: ":mode/:pathName/initial/momento",
      name: "actuacion-form-momento",
      component: () => import("@/pages/sumario/DenunciaFormMomento"),
      props: (route) => findPropsForRoute(route.params.pathName),
    },
    {
      path: ":mode/:pathName/initial/acusado",
      name: "actuacion-form-acusado",
      component: () => import("@/pages/sumario/DenunciaFormAcusado"),
      props: (route) => findPropsForRoute(route.params.pathName),
    },
    {
      path: ":mode/:pathName/initial/efectos",
      name: "actuacion-form-efectos",
      component: () => import("@/pages/sumario/DenunciaFormObjetos"),
      props: (route) => findPropsForRoute(route.params.pathName),
    },
    {
      path: ":mode/:pathName/initial/patrimonialAffectation",
      name: "actuacion-form-patrimonialAffectation",
      component: () => import("@/pages/sumario/DenunciaFormPatrimonialAffectation"),
      props: (route) => findPropsForRoute(route.params.pathName),
    },
    {
      path: ":mode/:pathName/:documento",
      name: "actuacion-save",
      component: () => import("@/pages/sumario/DenunciaPrint"),
    },
    {
      path: ":mode/:pathName/:id/addDiligencia",
      name: "actuacion-addDiligencia",
      component: () => import("@/pages/sumario/DenunciaPrint"),
    },
    {
      path: ":pathName/preview/:documento",
      name: "actuacion-previsualizar",
      component: () => import("@/pages/sumario/DenunciaPrint"),
    },
    {
      path: "newForm",
      name: "new-form",
      component: () => import("@/pages/NewFormPage"),
    },
    {
      path: ":pathName/print/edit/:id",
      name: "actuacion-edit-print",
      component: () => import("@/pages/sumario/DenunciaPrint"),
      props: true,
    },
  ],
};
